interface ShareTokenPayload {
  be?: string; // external email
  typeLabel?: string; // external role
  pid?: string; // participant id for individual assessments
  ts?: number; // timestamp
  v: number; // version
}

const SECRET = 'dacum-share-v1';

function hash(str: string) {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (Math.imul(31, h) + str.charCodeAt(i)) | 0;
  }
  return h.toString(36);
}

function toBase64Url(input: string): string {
  try {
    const encoder = new TextEncoder();
    const bytes = encoder.encode(input);
    let binary = '';
    for (let i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
    const b64 =
      typeof btoa === 'function'
        ? btoa(binary)
        : (globalThis as any).Buffer?.from(binary, 'binary').toString('base64');
    return (b64 || '').replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
  } catch {
    return '';
  }
}

function fromBase64Url(b64url: string): string {
  try {
    const b64 = b64url.replace(/-/g, '+').replace(/_/g, '/');
    const padded = b64 + '==='.slice((b64.length + 3) % 4);
    const binary =
      typeof atob === 'function'
        ? atob(padded)
        : (globalThis as any).Buffer?.from(padded, 'base64').toString('binary');
    if (!binary) return '';
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    const decoder = new TextDecoder();
    return decoder.decode(bytes);
  } catch {
    return '';
  }
}

export function encodeShareToken(data: { be?: string; typeLabel?: string; pid?: string }): string {
  const payload: ShareTokenPayload = {
    be: data.be,
    typeLabel: data.typeLabel,
    pid: data.pid,
    ts: Date.now(),
    v: 1
  };
  const json = JSON.stringify(payload);
  const b64 = toBase64Url(json);
  const sig = hash(b64 + SECRET);
  return `${b64}.${sig}`;
}

export function decodeShareToken(token: string): Partial<ShareTokenPayload> | null {
  if (!token) return null;
  const parts = token.split('.');
  if (parts.length !== 2) return null;
  const [b64, sig] = parts;
  const expected = hash(b64 + SECRET);
  if (expected !== sig) return null; // signature mismatch
  try {
    const json = fromBase64Url(b64);
    if (!json) return null;
    const payload = JSON.parse(json) as ShareTokenPayload;
    if (payload.ts && Date.now() - payload.ts > 1000 * 60 * 60 * 24 * 30) return null; // 30 day expiry
    return payload;
  } catch {
    return null;
  }
}
